import styled from "styled-components"

import { maxWidth } from "utils"

import Icon from "icons"

export const AdUnit = styled.section`
  margin: 4rem auto;
  text-align: center;
  .network-ad {
    height: ${({ maxHeight }) => maxHeight}px !important;
  }
  ${({ isInlineAd }) =>
    isInlineAd &&
    `
    .network-ad {
      display: flex;
      justify-content: center;
      align-items: center;
      height: auto;
    }
  `}

  ${maxWidth.mobile`
    ${({ isInlineAd }) =>
      isInlineAd &&
      ` 

        align-items: center;
        display: flex;
        justify-content: center;
        flex-direction: column;
        min-height: 34rem !important;
      `}

    
  `}
`

export const TitleWrapper = styled.div`
  position: relative;
  padding-bottom: 0.8rem;
  display: flex;
  justify-content: center;
  align-items: center;

  h5 {
    font-size: 1rem;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 0.2rem;
    color: #454545;
  }
`

export const Tooltip = styled.div`
  position: absolute;
  z-index: 1;
  top: calc(100% + 1.5rem);
  width: 28rem;
  padding: 2rem 3rem;
  border-radius: 0.6rem;
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.33;
  background-color: #fff;
  color: #454545;
  box-shadow: 0 1px 25px 0 rgba(145, 145, 145, 0.35);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s linear;

  ${maxWidth.mobile`
    left: 50%;
    transform: translateX(-50%);
  `}
`

export const IconWrapper = styled.div`
  margin-left: 1rem;
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover + ${Tooltip}, &:active + ${Tooltip}, &:focus + ${Tooltip} {
    opacity: 1;
  }
`

export const InfoIcon = styled(Icon)`
  width: 1.4rem;
  height: 1.4rem;

  path {
    fill: #454545;
  }
`

export const TooltipText = styled.div`
  color: #454545;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
`
